import { AxiosError } from 'axios';
import * as profileActions from '../actions/profile';

export interface IProfileState {
  changingPassword: boolean;
  changePasswordError?: AxiosError;
  changePasswordSuccess: boolean;
}

const initialState: IProfileState = {
  changingPassword: false,
  changePasswordSuccess: false
};

export default function (
  state: IProfileState = initialState,
  action
): IProfileState {
  switch (action.type) {
    case profileActions.PROFILE_PASSWORD_SAVING:
      return {
        ...state,
        changingPassword: true,
        changePasswordError: null,
        changePasswordSuccess: false
      };

    case profileActions.PROFILE_PASSWORD_SAVE_SUCCESS:
      return {
        ...state,
        changingPassword: false,
        changePasswordError: null,
        changePasswordSuccess: true
      };

    case profileActions.PROFILE_PASSWORD_SAVE_FAILURE:
      return {
        ...state,
        changingPassword: false,
        changePasswordError: action.error,
        changePasswordSuccess: false
      };
  }

  return state;
}
